import { Guid } from "@/types"
import Notification, { IGetNotification } from "./Notification"
import NotificationAsset from "./NotificationAsset"

export interface IGetNotificationManualStoreCompletedDto extends IGetNotification {
    reservationId: Guid
    reservationNumber: string
    shippingOrderId?: Guid
    shippingOrderNumber?: string
    inspectionRequiredFor?: Guid[] | null
}

export default class NotificationManualStoreCompleted extends Notification {
    reservationId: Guid
    reservationNumber: string
    shippingOrderId?: Guid
    shippingOrderNumber?: string
    inspectionRequiredForIds: Guid[]
    inspectionRequiredFor: NotificationAsset[]

    constructor(dto: IGetNotificationManualStoreCompletedDto) {
        super(dto)
        this.reservationId = dto.reservationId
        this.reservationNumber = dto.reservationNumber
        this.shippingOrderId = dto.shippingOrderId
        this.shippingOrderNumber = dto.shippingOrderNumber
        this.inspectionRequiredForIds = dto.inspectionRequiredFor ?? []
        this.inspectionRequiredFor = dto.inspectionRequiredFor?.map(assetId => new NotificationAsset({ assetId })) ?? []
    }
}
